import { DPRS } from '@packages/media/constants/resolution.ts'

const IMAGE_SIZE_WIDTH_STEP_PX = 500
const IMAGE_SIZE_HEIGHT_STEP_PX = 500
const IMAGE_SIZE_MAX_PX = 2000

const findClosestStep = (raw, step) => (raw % step === 0)
  ? raw
  : (Math.ceil(raw / step) || 1) * step

const findClosestSizeStep = ({ h, w }) => {
  const calculated = {}

  if (h !== undefined) {
    calculated.h = Math.min(
      IMAGE_SIZE_MAX_PX,
      findClosestStep(h, IMAGE_SIZE_HEIGHT_STEP_PX) || IMAGE_SIZE_HEIGHT_STEP_PX
    )
  }
  if (w !== undefined) {
    calculated.w = Math.min(
      IMAGE_SIZE_MAX_PX,
      findClosestStep(w, IMAGE_SIZE_WIDTH_STEP_PX) || IMAGE_SIZE_HEIGHT_STEP_PX
    )
  }

  return calculated
}

const findContainerAwareImageSize = ($container) => {
  const containerHeight = $container?.offsetHeight || window?.innerHeight || 0
  const containerWidth = $container?.offsetWidth || window?.innerWidth || 0

  let size = containerWidth
  let sizeDimension = 'w'
  if (containerHeight >= containerWidth) {
    size = containerHeight
    sizeDimension = 'h'
  }

  const h = Math.min(IMAGE_SIZE_MAX_PX, findClosestStep(containerHeight, IMAGE_SIZE_HEIGHT_STEP_PX))
  const w = Math.min(IMAGE_SIZE_MAX_PX, findClosestStep(containerWidth, IMAGE_SIZE_WIDTH_STEP_PX))

  return {
    w, h, size, sizeDimension,
  }
}

const getDpr = () => window?.devicePixelRatio || null

// Snapped to the DPRS ladder so odd device ratios reuse a cached variant instead of adding one
const findClosestSupportedDpr = dpr => DPRS.find(supportedDpr => supportedDpr >= dpr) ?? DPRS.at(-1)

const parseDpr = () => {
  const dpr = getDpr()

  if (dpr === null) {
    return 'auto'
  }

  return findClosestSupportedDpr(dpr).toFixed(1)
}
export {
  IMAGE_SIZE_WIDTH_STEP_PX,
  IMAGE_SIZE_HEIGHT_STEP_PX,
  IMAGE_SIZE_MAX_PX,
  findClosestSizeStep,
  findContainerAwareImageSize,
  getDpr,
  parseDpr,
}
